import { useEffect, useState } from 'react'

import { isRegistrationClosed, registrationClosesAt } from 'constants/registration'

const useRegistrationStatus = (): boolean => {
    const [registrationClosed, setRegistrationClosed] = useState(isRegistrationClosed)

    useEffect(() => {
        if (registrationClosed) {
            return undefined
        }

        const timeout = window.setTimeout(() => {
            setRegistrationClosed(true)
        }, Math.max(registrationClosesAt.getTime() - Date.now(), 0))

        return () => window.clearTimeout(timeout)
    }, [registrationClosed])

    return registrationClosed
}

export default useRegistrationStatus